import React from 'react';
import { Link } from 'react-router';

const LandSearchListItem = (props) => {
    let divclasses = "brd-top";

    let enquire =
        <a className="btn btn__enquire js-modalOpen fr" role="button" href="#" data-toggle="modal" data-target="#RegisterModal">
            <span className="btn-land-available">ENQUIRE</span>
            <span className="btn-land-sold dn">SOLD</span>
        </a>;

    let link = props.data.link;

    let statusTxt = <span className="p-l-2-lg small-blue-font fcolor-gr db di-lg m-t-05 m-t-0-lg land-available">AVAILABLE</span>;

    let flyer = <a className="download-flyer" href={props.data.pdf} target="_blank">
                    <i className="icon icon--download-alt"></i>
                    <span className="small-grey-font dn di-md">Download Flyer</span>
                </a>;

    if(props.data.status === 2) {
        divclasses += " land-sold";
        enquire =
            <a className="btn btn__enquire js-modalOpen fr">
                <span className="btn-land-available">ENQUIRE</span>
                <span className="btn-land-sold dn">SOLD</span>
            </a>;
        link = "";
        flyer = "";
    }
    if(props.data.status === 3) {
        statusTxt = <span className="p-l-2-lg small-blue-font fcolor-bl db di-lg m-t-05 m-t-0-lg land-available">BUILDERS EXCL.</span>;
    }

    return (
            <li className={divclasses}>
                <div className="cf">
                    <Link to={link}>
                        <div className="w-25 fl tl p-l-2-lg">
                            <div className="w-100 fl small-blue-font">LOT {props.data.name}
                                {statusTxt}
                                <span className="p-l-2-lg small-blue-font m-t-05 fcolor-gray m-t-0-lg land-sold-text dn">SOLD</span>
                            </div>

                        </div>
                        <div className="w-30-lg w-30-md w-40 fl tc-lg tl">
                            <div className="w-50-lg w-100 fl m-b-05 m-b-0-wd small-grey-font tl">Frontage<span className="fcolor-og small-grey-font"> {props.data.frontage}m</span></div>
                            <div className="w-50-lg w-100 fl small-grey-font tl">Land Size<span className="fcolor-og small-grey-font"> {props.data.area}m<sup>2</sup></span></div>
                        </div>
                    </Link>

                    <div className="w-30-lg w-20 fl tc-lg tl p-t-0-lg p-t-05">
                        <div className="w-50-lg w-100 fl small-grey-font dn db-lg">{props.data.packages} Packages</div>
                        <div className="w-50-lg w-100 fl tc">
                            {flyer}
                        </div>
                    </div>

                    <div className="w-15 fr fl-lg p-r-2-lg p-t-0-md p-t-05">
                        <div className="btn__container tc tl-md">
                            {enquire}
                            <a className="btn-enquire-mob js-modalOpen" role="button" href="#" data-toggle="modal" data-target="#RegisterModal">
                                <i className="icon icon--mail"></i>
                            </a>

                        </div>
                    </div>
                </div>
            </li>
    );
};

export default LandSearchListItem;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchListItem.js
 **/